import React, { useEffect } from 'react'
import formatCurrency from 'format-currency'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { I18n } from 'react-redux-i18n'

import { customPaymentAct, composerAct } from '../../../../../../redux/actions'
import dkvConfiguration from 'constants/dkv.constants'
import { lang } from 'utils/helpers'
import { TextNumberFormat, Button } from 'components/Form'

import './styles.scss'
import TextInputField from 'components/Form/TextInputField'
import Nixi1Spinner from 'components/Nixi1Spinner'
const formatCurrencyOptions = {
  format: '%v',
  locale: 'es-ES',
}

const CustomPayment = (props) => {

  const { user, plugin: { concept, price, bondNumber, commission, total, link, gettingLink, errors } } = props

  const customPayment = bindActionCreators(customPaymentAct, props.dispatch)
  const onChatComposer = bindActionCreators(composerAct, props.dispatch)

  useEffect(() => {
    return () => {
      onReset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onChange = ({ target })=>{
    customPayment.updateData(user.id, { [target.name]: target.value })
  }

  const onReset = ()=>{
    customPayment.resetCustomPayment(user.id, true)

  }

  const onCreateLink = ()=>{
    customPayment.createLink(user, price, concept, bondNumber)
  }

  const onSend =()=>{
    onChatComposer.addExternalText(`${I18n.t('dashboard_secure-link-payment')}▶️ ${link} ◀️`)
    customPayment.resetCustomPayment(user.id)
  }

  return (
    <div className='container-payment-custom'>
      {link && (
        <div className='icon-reset'>
          <i className='fa fa-times cursor-pointer' onClick={onReset}/>
        </div>
      )}
      {dkvConfiguration.isDKV && (
        <div className='container-input'>
          {link ? (
            <p>{bondNumber}</p>
          ):(
            <TextInputField 
              type='text'
              id={'bondNumber'}
              name={'bondNumber'}
              value={bondNumber}
              onChange={(value)=> onChange({ target: { name: 'bondNumber', value } })}
              label={I18n.t('custom_payment_bond_number')}
              className={'plugin-payment__input'}
            />
          )}
        </div>
      )}

      <div className='container-input'>
        {link ? (
          <p>{concept}</p>
        ): (
          <div>
            <label>
              {I18n.t('dashboard_concept')}
            </label>
            <TextInputField
              type='text'
              value={concept}
              name='concept'
              id='concept'
              onChange={(value)=> onChange({ target:{ name:'concept', value } })}
              className={'plugin-payment__input no-border'}
            />
          </div>
        )}
      </div>

      {!link ? (
        <div className='container-input direction'>
          <div style={{ width: '25%' }}>
            <div className='formGroupPrice'>
              <TextNumberFormat 
                defaultValue={price}
                value={price}
                id='price'
                name='price'
                onChange={value => onChange({ target: { name: 'price', value: isNaN(value) ? 0 : value } })}
                className={'new-input price plugin-payment__input'}
              />
              <span className='input-group-text wrapper-icon-euro-price'>
                <i className='fa fa-eur'></i>
              </span>
            </div>
          </div>
          <div style={{ width: '70%' }}>
            <Button
              className={'button-create-link'}
              primary
              onClick={onCreateLink}
              disabled={price <= 0 || !(dkvConfiguration.isDKV ? bondNumber : concept)}
            >
              {I18n.t('dashboard_create-link')}
            </Button>
          </div>
        </div>
      ):(
        <div className='container-input' style={{ fontSize:'13px' }}>
          <div className='information-payment'>
            <strong>{I18n.t('dashboard_price')}:</strong>
            {formatCurrency(price, formatCurrencyOptions)} €
          </div>

          <div className='information-payment'>
            <strong>{I18n.t('dashboard_administration-fees')}:</strong>
            {formatCurrency(commission, formatCurrencyOptions)} €
          </div>

          <div className='information-payment'>
            <strong>{I18n.t('dashboard_total')}:</strong>
            {formatCurrency(total, formatCurrencyOptions)} €
          </div>
        </div>
      )}

      {link &&(
        <div className='verify-link'>
          <a href={link} target='_blank' rel='noopener noreferrer'>
            {I18n.t('dashboard_verify-that-link-works')}
          </a>
        </div>
      )}

      {Object.keys(errors).length > 0 && (
        <div style={{ marginTop: '1rem' }}>
          {Object.keys(errors).map((e, i) => (
            <div key={i}>
              <span className='text-danger'>{I18n.t(errors[e])}</span>
            </div>
          ))}
        </div>
      )}

      {gettingLink?(
        <div style={{ paddingTop: '15px' }}>
          <Nixi1Spinner height='30px' width='100%' />
        </div>
      ): (
        link &&
        <div className='container-copy-buttons'>
          <Button
            primary
            onClick={onSend}
            className='buttonCreateNewPaymentLink'
          >
            <label>
              {I18n.t('dashboard_copy-to-chat')}
            </label>
          </Button>

          <Button
            primary
            className='buttonCreateNewPaymentLink'
            onClick={() => {
              navigator.clipboard.writeText(`${I18n.t('dashboard_link-payment-with-time-10m')}▶️ ${link} ◀️`)
            }}
          >
            <label>
              {lang('messages_link_payment_clipboard')}
            </label>
          </Button>
        </div>
      )}

    </div>
  )
}

export default connect()(CustomPayment)
